var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.83,22.08a2.11,2.11,0,0,1,2.29,0,3.89,3.89,0,0,1,5.24-1.67,4,4,0,0,1,1.48,1.33h1a.7.7,0,0,1,.73.68.71.71,0,0,1-.68.74H26.4a3.89,3.89,0,1,1-7.65,1.4,3.23,3.23,0,0,1-.07-.69.71.71,0,0,0-1.41,0,3.9,3.9,0,0,1-7.79,0,3.26,3.26,0,0,1,.07-.7H9.13a.71.71,0,1,1-.05-1.42h1A3.9,3.9,0,0,1,15.5,20.6a4,4,0,0,1,1.33,1.48Zm5.74,4.26a2.48,2.48,0,1,0-2.47-2.47h0a2.48,2.48,0,0,0,2.47,2.47Zm-9.2,0a2.48,2.48,0,1,0-2.47-2.47h0a2.48,2.48,0,0,0,2.47,2.47h0Zm-4.14-9.2,1-6.84a2.27,2.27,0,0,1,3.24-1.83l2.16.91a7.06,7.06,0,0,0,4.67,0l2.16-.91a2.26,2.26,0,0,1,3,1.07,2,2,0,0,1,.21.76l1,6.84h2.57a.71.71,0,0,1,.06,1.42H6.65a.71.71,0,0,1,0-1.42ZM24.82,14l-.51-3.46a.87.87,0,0,0-.89-.84.8.8,0,0,0-.4.11l-2.16.91a8.42,8.42,0,0,1-5.77,0l-2.16-.91a.87.87,0,0,0-1.18.33.92.92,0,0,0-.11.4L11.13,14Z",
    fill: "#624de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.9e88af02aad81bb56653d7174a2c7095.svg";
export { ForwardRef as ReactComponent };